import {h, Fragment} from "preact"
import { useFacets } from '@nosto/preact';
import Facet from './Facet';
import FacetCustomized from './FacetCustomized';
import RangeFacet from './RangeFacet';
import Icon from './elements/Icon';
import { useState } from 'preact/hooks';
import Sort from './Sort';

function ToggleSidebarButton({ className }) {
  return (
    <label
      className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
      for="toggle-mobile-sidebar"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="icon icon-close"
      >
        <path
          fill-rule="evenodd"
          d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
          clip-rule="evenodd"
        ></path>
      </svg>
    </label>
  );
}

export default function SidebarCustomized({
  toggleId,
  children,
  isMobileView,
}) {
  const { loading, facets } = useFacets();
  const [activeFacet, setActiveFacet] = useState('');

  return facets?.length > 0 ? (
    <>
      <input
        type="checkbox"
        id={toggleId}
        class="ns-facet-sidebar-toggle ns-d-none"
      />
      <label
        class={
          'ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none'
        }
        for="toggle-mobile-sidebar"
      />
      <div
        // ns-h-100
        class={`${
          !isMobileView ? 'nsc-side-wrapper--desktop' : ''
        } ns-sidebar-wrapper ns-d-none ns-d-md-block  ns-col-3 ns-col-l-2`}
        style={loading ? 'opacity: 0.3;' : ''}
      >
        <div
          class={`ns-sidebar-content ns-relative ns-background-white ${
            isMobileView ? 'ns-h-100' : ''
          } ns-mr-0 ns-mr-md-auto`}
        >
          {isMobileView && (
            <div class="ns-sidebar-header ns-d-flex ns-align-items-baseline ns-justify-content-center ns-p-4">
              <ToggleSidebarButton />
              <span class="ns-font-medium ns-color-black ns-text-align-center">
                FILTER
              </span>
            </div>
          )}
          <div
            class={`ns-sidebar-menu ns-d-flex ns-justify-content-between ${
              isMobileView ? 'ns-vh-100' : ''
            }`}
          >
            <ul class="ns-list-unstyled ns-p-0 ns-m-0 nsc-sidebar-menu__list ns-flex-fill">
              {facets?.map((facet) => {
                switch (facet.type) {
                  case 'terms':
                    return (
                      <FacetCustomized
                        facet={facet}
                        isActive={activeFacet === facet.id}
                        setActive={(prevValue) => {
                          if (prevValue) {
                            setActiveFacet(facet.id);
                          } else {
                            setActiveFacet('');
                          }
                        }}
                      />
                    );
                  case 'stats':
                    return (
                      <RangeFacet
                        facet={facet}
                        isActive={activeFacet === facet.id}
                        setActive={(prevValue) => {
                          if (prevValue) {
                            setActiveFacet(facet.id);
                          } else {
                            setActiveFacet('');
                          }
                        }}
                      />
                    );
                  default:
                    return null;
                }
              })}
            </ul>
            <Sort />
          </div>
        </div>
        {children}
      </div>
    </>
  ) : (
    ''
  );
}
